// ========== 星星触发系统 ==========
export class StarTriggerSystem {
    constructor() {
        this.hero = document.querySelector('.hero');
        if (!this.hero) return;

        this.allParticles = Array.from(document.querySelectorAll('.particle'));
        this.activeStars = 0;
        this.targetMin = 15;
        this.targetMax = 25;
        this.starPool = [];
        this.maxPoolSize = 30;
        
        this.createStarContainer();
        this.init();
    }
    
    createStarContainer() {
        this.starContainer = document.createElement('div');
        this.starContainer.className = 'star-container';
        this.starContainer.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 15;
            overflow: visible;
        `;
        this.hero.appendChild(this.starContainer);
    }
    
    init() {
        this.initStarPool();
        this.scheduleStars();
        
        if (window.location.search.includes('debug')) {
            this.startMonitoring();
        }
    }
    
    initStarPool() {
        for (let i = 0; i < this.maxPoolSize; i++) {
            const star = this.createStarElement();
            star.isActive = false;
            this.starPool.push(star);
        }
    }
    
    createStarElement() {
        const star = document.createElement('div');
        star.className = 'hero-star';
        return star;
    }
    
    getAvailableStar() {
        let star = this.starPool.find(s => !s.isActive);
        if (!star) {
            star = this.createStarElement();
        }
        return star;
    }
    
    scheduleStars() {
        this.allParticles.forEach((particle) => {
            const durationStr = particle.style.animationDuration;
            const delayStr = particle.style.animationDelay;
            const left = particle.style.left;
            
            if (!durationStr || !delayStr || !left) return;
            
            const duration = parseFloat(durationStr) * 1000;
            const delay = parseFloat(delayStr) * 1000;
            const triggerPoint = 0.95;
            
            const scheduleNext = () => {
                const triggerTime = duration * triggerPoint;
                
                setTimeout(() => {
                    const starCount = this.getStarCount();
                    
                    for (let i = 0; i < starCount; i++) {
                        const baseLeft = parseFloat(left);
                        const offsetLeft = baseLeft + (Math.random() - 0.5) * 6;
                        const clampedLeft = Math.max(5, Math.min(95, offsetLeft));
                        this.createStar(clampedLeft + '%');
                    }
                    
                    scheduleNext();
                }, triggerTime);
            };
            
            const firstTriggerTime = delay + duration * triggerPoint;
            
            if (firstTriggerTime > 0) {
                setTimeout(() => {
                    const starCount = this.getStarCount();
                    for (let i = 0; i < starCount; i++) {
                        const baseLeft = parseFloat(left);
                        const offsetLeft = baseLeft + (Math.random() - 0.5) * 6;
                        const clampedLeft = Math.max(5, Math.min(95, offsetLeft));
                        this.createStar(clampedLeft + '%');
                    }
                    scheduleNext();
                }, firstTriggerTime);
            } else {
                const nextTriggerTime = firstTriggerTime + duration;
                if (nextTriggerTime > 0) {
                    setTimeout(() => {
                        const starCount = this.getStarCount();
                        for (let i = 0; i < starCount; i++) {
                            const baseLeft = parseFloat(left);
                            const offsetLeft = baseLeft + (Math.random() - 0.5) * 6;
                            const clampedLeft = Math.max(5, Math.min(95, offsetLeft));
                            this.createStar(clampedLeft + '%');
                        }
                        scheduleNext();
                    }, nextTriggerTime);
                } else {
                    scheduleNext();
                }
            }
        });
    }
    
    getStarCount() {
        if (this.activeStars < this.targetMin) {
            const r = Math.random();
            if (r < 0.3) return 2;
            if (r < 0.9) return 1;
            return 0;
        }
        
        if (this.activeStars > this.targetMax) {
            return Math.random() < 0.05 ? 1 : 0;
        }
        
        const ratio = (this.activeStars - this.targetMin) / (this.targetMax - this.targetMin);
        const probability = 1 - ratio * 0.8;
        
        if (Math.random() < probability) {
            return Math.random() < 0.15 ? 2 : 1;
        }
        
        return 0;
    }
    
    createStar(left) {
        const star = this.getAvailableStar();
        star.isActive = true;
        this.activeStars++;
        
        const top = 10 + Math.random() * 20;
        star.style.left = left;
        star.style.top = top + '%';
        
        const scale = 0.7 + Math.random() * 0.3;
        star.style.setProperty('--star-scale', scale);
        
        const speed = 0.9 + Math.random() * 0.2;
        star.style.animationDuration = (12 / speed) + 's';
        
        star.classList.remove('active');
        void star.offsetWidth;
        star.classList.add('active');
        
        if (!star.parentElement) {
            this.starContainer.appendChild(star);
        }
        
        setTimeout(() => {
            star.isActive = false;
            star.classList.remove('active');
            this.activeStars--;
        }, 12000);
    }
    
    startMonitoring() {
        setInterval(() => {
            console.log(`⭐ 当前星星数量: ${this.activeStars}个 (目标: ${this.targetMin}-${this.targetMax})`);
        }, 3000);
    }
}

export function initStarSystem() {
    setTimeout(() => {
        new StarTriggerSystem();
    }, 100);
}
